import { ENV } from '../../config/runtimeEnv';
import type {
	GenotyperRun,
	GenotyperRunResponse,
	SampleGenotyper,
	SampleGenotyperResponse,
} from "../../types/lab/GenotyperTypes";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_LABIQ_SERVER;

// Latest genotyper run for a gsa_raw result; 404 until the upload has created one
export const fetchGenotyperRun = async (resultId: number): Promise<GenotyperRun> => {
	const response = await http.get<GenotyperRunResponse>(`${API_BASE_URL}/results/${resultId}/genotyper-run`);

	return response.data.data;
};

// Per-sample CNV / PGx / mtDNA rows plus the run they came from
export const fetchSampleGenotyper = async (sampleId: string): Promise<SampleGenotyper> => {
	const response = await http.get<SampleGenotyperResponse>(
		`${API_BASE_URL}/samples/${encodeURIComponent(sampleId)}/genotyper`
	);

	return response.data.data;
};

// The results zip as a blob; 404 until artifact_file_id is set on the run
export const downloadGenotyperArtifact = async (runId: number): Promise<Blob> => {
	const response = await http.get(`${API_BASE_URL}/genotyper/runs/${runId}/artifact`, {
		responseType: 'blob',
	});

	return response.data;
};

// Built client-side because labiq's CorsMiddleware exposes no Content-Disposition cross-origin.
export const genotyperArtifactFilename = (runId: number): string => `genotyper_run_${runId}_results.zip`;

export const saveGenotyperArtifact = async (runId: number): Promise<void> => {
	const blob = await downloadGenotyperArtifact(runId);
	const url = window.URL.createObjectURL(blob);

	const a = document.createElement('a');
	a.href = url;
	a.download = genotyperArtifactFilename(runId);
	document.body.appendChild(a);

	try {
		a.click();
	} finally {
		document.body.removeChild(a);
		window.URL.revokeObjectURL(url);
	}
};
